import { AppBar, Toolbar, Typography, IconButton, Tooltip, Tabs, Tab, Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import RefreshIcon from '@mui/icons-material/Refresh';

const NavBar = ({ page, onPageChange, onLogout, onRefresh, loading }) => {
  const userName = (() => {
    try {
      const u = JSON.parse(localStorage.getItem('stats_user') || '{}');
      return u.firstName ? `${u.firstName} ${u.lastName}` : null;
    } catch { return null; }
  })();

  return (
    <AppBar position="sticky" sx={{ bgcolor: '#0d3c61' }}>
      <Toolbar>
        <TrendingUpIcon sx={{ mr: 1.5 }} />
        <Typography variant="h6" sx={{ fontWeight: 700, mr: 4 }}>AirMaxx Statistics</Typography>
        <Tabs
          value={page}
          onChange={(_, v) => onPageChange(v)}
          textColor="inherit"
          TabIndicatorProps={{ style: { background: '#fff', height: 3 } }}
          sx={{ flexGrow: 1, '& .MuiTab-root': { minHeight: 64, fontWeight: 600, fontSize: 13, opacity: 0.7, '&.Mui-selected': { opacity: 1 } } }}
        >
          <Tab label="Dashboard" value="dashboard" />
          <Tab label="Marketing Analytics" value="analytics" />
        </Tabs>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {userName && (
            <Typography variant="body2" sx={{ mr: 2, opacity: 0.8 }}>{userName}</Typography>
          )}
          {onRefresh && (
            <Tooltip title="Refresh">
              <IconButton color="inherit" onClick={onRefresh} disabled={loading}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Logout">
            <IconButton color="inherit" onClick={onLogout}><LogoutIcon /></IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
